import React from 'react';
import { useLocation } from '@gatsbyjs/reach-router';
import { useHeaderNav } from '@hooks/useHeaderNav';
import { Alerts, CustomAlerts } from '@components/Blocks/Alerts';
import type { StrapiHeaderNavItem } from '@customTypes/strapiData';
import { DesktopHeader } from '@components/Blocks/Navigation/DesktopHeader';
import { MobileHeader } from '@components/Blocks/Navigation/MobileHeader';

import * as styles from './Navigation.module.css';

export function Navigation() {
  const headerMenuItems: StrapiHeaderNavItem[] = useHeaderNav();
  const location = useLocation();
  const isMainPage = location.pathname === '/';

  // mobile header height + scroll width
  const scrollOffset = isMainPage ? 116 : 68;

  return (
    <>
      <div className={styles.mobileNavigation} style={{ marginBottom: `${scrollOffset}px` }}>
        <Alerts />
        <CustomAlerts />
        {headerMenuItems.length && (
          <MobileHeader
            items={headerMenuItems}
            scrollOffset={scrollOffset}
            isMainPage={isMainPage}
          />
        )}
      </div>
      <div className={styles.desktopNavigation}>
        <Alerts />
        <CustomAlerts />
        {headerMenuItems.length && <DesktopHeader items={headerMenuItems} />}
        <div id="product-info-desktop" className={styles.productInfoContainer} />
      </div>
    </>
  );
}
